import { Clear, Home } from "@mui/icons-material";
import { FormControl, FormHelperText, FormLabel, Icon, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ErrorMessage, FormikProvider, useFormik } from "formik";
import { useTranslation } from "react-i18next";
import {useHistory, useParams} from "react-router-dom";
import * as yup from "yup";
import { getRouteUrl } from "../../helpers/routing/getRouteUrl";
import { formControlDefaults, textFieldDefaults } from "../../helpers/theme/defaultProps";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";
import {ROUTE_PAGE_HOME, ROUTE_PAGE_INITIAL, ROUTE_PAGE_LOGIN, ROUTE_VERIFICATION} from "../../routers/routes";
import InputLine from "../../components/custom/ui/inputLine";
import axios from "axios";
import {getEndPoint} from "../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../helpers/errorHandling";
import {useUser} from "../../userContext/userContext";
import {LoadingButton} from "@mui/lab";
import {useState} from "react";
import InitialChangePass from "../changePassword/initialChangePassword";

const Form = (props) => {
	const {verificationId} = useUser()
	const { t } = useTranslation(PAGE_LOGIN)
	const history = useHistory()
	const {campaign} = useParams()
	const [loading,setLoading] = useState(false)

	function onSubmit(values) {
		const payload = {
			id:verificationId,
			emailvalidationcode:values.emailPassword,
			mobilephonevalidationcode:values.mobilePassword,
			website: "",
			oldapplicant: ""
		};
		setLoading(true)
		axios({
			method: 'post',
			url: getEndPoint('applicantMobileVerification'),
			data: payload,
			headers: { 'Content-Type': 'application/json' },
		})
			.then(() => {
				setLoading(false)
				history.push(getRouteUrl(ROUTE_PAGE_INITIAL, { campaign }));
			})
			.catch((error) => {
				setLoading(false)
				history.push(getRouteUrl(ROUTE_PAGE_LOGIN, { campaign }));
				enqueueSnackbar(t("Verification failed!"), {
					variant: 'error',
				});
			});
	}
	
	const validationSchema = yup.object({
		mobilePassword: yup
		.string()
		.required(t('Required')),
		emailPassword: yup
		.string()
		.required(t('Required')),
	})
	
	const formik = useFormik({
		initialValues: {
			mobilePassword: '',
			emailPassword: '',
		},
		validationSchema: validationSchema,
		onSubmit: onSubmit,
	})
	return (
		<FormikProvider value={formik}>
			<Box
				sx={{
					padding: {
						xs: '6px 14px',
						sm: '12px 28px',
						md: '46px'
					}
				}}
				component="form"
				onSubmit={formik.handleSubmit}
				noValidate
			>
				<Box
					width="100%"
				>
						<InputLine
							isVerification={true}
							autoFocus
							name={'mobilePassword'}
							value={formik.values.mobilePassword}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							required
							label={t("Mobile Verification Code")}
							error={formik.touched.mobilePassword && formik.errors.mobilePassword}
							helperText={formik.errors.mobilePassword}
						/>

						<InputLine
							isVerification={true}
							autoFocus
							name={'emailPassword'}
							value={formik.values.emailPassword}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							required
							label={t("Verification Code from email")}
							error={formik.touched.emailPassword && formik.errors.emailPassword}
							helperText={formik.errors.emailPassword}
						/>
					<LoadingButton
						loading={loading}
						fullWidth
						variant="contained"
						type="submit"
						sx={{
							background: "#fff",
							color: "#004B88",
							mt: 2,
							height: 44,
							borderRadius: 1,
							textTransform: "none",
							fontWeight: 600
						}}
					>
						{t("Continue")}
					</LoadingButton>

					<Button
						fullWidth
						variant="outlined"
						startIcon={<Clear />}
						sx={{
							mt: 2,
							height: 44,
							textTransform: "none",
							borderColor: "rgba(255,255,255,0.7)",
							color: "#fff",
							"&:hover": {
								borderColor: "#fff",
								background: "rgba(255,255,255,0.1)"
							}
						}}
						onClick={(event) => {
							formik.resetForm();
							event.currentTarget.blur();
						}}
					>
						{t("Clear")}
					</Button>
				</Box>
			</Box>
		</FormikProvider>
	);
};

export default Form